'use strict';

class PageContact {

    constructor($target) {

        //Private properties
        $target;

        let label = $target.find('.label-txt');
        let input = $target.find('.wpcf7-form-control');
        let inputWrap = $target.find('.wpcf7-form-control-wrap');
        let line = $target.find('.line-box');
        let textarea = $target.find('textarea');

        textarea.cols = "100";


        function init() {
            removeElementsRedundant();
        }

        function removeElementsRedundant() {
            //remove hint to show animation
            $(input).each(
                function () {
                    $(this).data('holder', $(this).attr('placeholder'));
                    $(this).focusin(function () {
                        $(this).attr('placeholder', '');
                    });
                    $(this).focusout(function () {
                        $(this).attr('placeholder', $(this).data('holder'));
                    });
                    

                });

            ///line input animation active
            $(line).each((index, value) => {
                $(value).appendTo(inputWrap[index])
            });

            ///input on focus
            $(input).each((index, value) => {
                // $(value).appendTo(inputWrap[index])
                $(value).focus(function(){
                    $(label[index]).addClass('label-active');
                  });

                  $(value).focusout(function(){
                    $(label[index]).removeClass('label-active');
                    if ($(value).val() == '') {
                        $(label[index]).removeClass('label-active');
                    };
                  });
        
            });

  
            ///textarea on focus
            $(textarea).focus(function () {
                $(this).addClass("expanding")
                $(this).animate({
                    height: "10em"
                }, 500);
            });
            $(textarea).blur(function () {
                $(this).animate({
                    height: "2em"
                }, 500);
                $(this).removeClass("expanding")
            });

        }

        init();

        return {

         
            publicPageContact: function (string) {

            }

        }

    }

}

export default PageContact;